module.exports = __webpack_public_path__ + "img/note.0d524240.svg";